if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        this.setLoading(false);
        const opener = this.openedBy;
        this.openedBy = null; // Prevent super.hide() from focusing and scrolling
        super.hide();
        // Manually restore focus without scrolling
        if (opener) opener.focus({ preventScroll: true });
      }

      show(opener) {
        super.show(opener);
        this.setLoading(true);
        this.querySelectorAll('.product-media-modal__content img').forEach((img) => {
          img.loading = 'eager';
        });
        this.showActiveMedia();
      }

      setLoading(isLoading) {
        this.classList.toggle('product-media-modal--loading', Boolean(isLoading));
      }

      ensureMediaReady(activeMedia) {
        const activeImage = activeMedia.nodeName === 'IMG' ? activeMedia : activeMedia.querySelector('img');
        if (!activeImage) {
          this.setLoading(false);
          return;
        }

        if (activeImage.complete && activeImage.naturalWidth > 0) {
          this.setLoading(false);
          return;
        }

        this.setLoading(true);
        const onDone = () => this.setLoading(false);
        activeImage.addEventListener('load', onDone, { once: true });
        activeImage.addEventListener('error', onDone, { once: true });
      }

      showActiveMedia() {
        const openedByMediaId = this.openedBy?.getAttribute('data-media-id');
        const mediaSelector = '.product-media-modal__content > [data-media-id]';

        // Remove active class from all direct modal media elements.
        this.querySelectorAll(mediaSelector).forEach((element) => {
          element.classList.remove('active');
        });

        const escapedMediaId =
          openedByMediaId && window.CSS?.escape ? window.CSS.escape(openedByMediaId) : openedByMediaId;

        // Prefer the clicked media, otherwise fallback to first media to avoid blank modal.
        let activeMedia = escapedMediaId
          ? this.querySelector(`.product-media-modal__content > [data-media-id="${escapedMediaId}"]`)
          : null;

        if (!activeMedia) {
          activeMedia = this.querySelector(mediaSelector);
        }

        if (!activeMedia) {
          this.setLoading(false);
          return;
        }

        activeMedia.classList.add('active');

        // Ensure selected image starts loading immediately.
        const activeImage = activeMedia.nodeName === 'IMG' ? activeMedia : activeMedia.querySelector('img');
        if (activeImage) {
          activeImage.loading = 'eager';
          activeImage.fetchPriority = 'high';
          if (activeImage.decode) activeImage.decode().catch(() => {});
          if (!activeImage.getAttribute('src') && activeImage.dataset?.src) {
            activeImage.setAttribute('src', activeImage.dataset.src);
          }
        }

        this.ensureMediaReady(activeMedia);

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
